export const SITE_CONFIG = {
    name: "Little Star Kids Academy",
    email: "ajaymumbai222@gmail.com",
    phone: "+919322219327",
    address: "Sankalp Nagar, Camp, Malegaon, Nashik, Maharashtra 423105",
    mapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.4!2d74.5!3d20.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bde972fac567dad%3A0x7ca29445715564a1!2sLondon%20kids%20preschool%20Sankalp%20Nagar%2C%20Camp%2C%20Malegaon!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
    whatsappNumber: "919322219327", // Enter number without + or spaces
    socials: {
        facebook: "#",
        instagram: "#",
        twitter: "#"
    }
};

export const ROUTES = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Programs', path: '/programs' },
    { name: 'Facilities', path: '/facilities' },
    { name: 'Franchise', path: '/franchise' },
    { name: 'Contact', path: '/contact' },
];

export const IMAGES = {
    // Branding
    logo: '/little-star.png',

    // Home Page
    hero: '/hero-kids.jpg',      // Replace with your hero image
    homeAbout1: '/about-playing.jpg', // Replace with kids playing image
    homeAbout2: '/about-classroom.jpg', // Replace with classroom image

    // About Page
    aboutMain: '/about-teacher.jpg', // Replace with teacher/students image

    // Facilities Page
    facilityOutdoor: '/play-area.jpg',
    facilityClassroom: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=800&q=80',
    facilityIndoor: '/facility-indoor.jpg',
    facilityLearning: '/facility-interactive.jpg',
};
